module.exports = __webpack_public_path__ + "img/logo_deutsche_post.fd4c64a5.svg";